import {
  Sheet as ShadSheet,
  SheetContent as ShadSheetContent,
  SheetHeader as ShadSheetHeader,
  SheetTitle as ShadSheetTitle,
} from "@/components/ui/sheet"
import Button from "@/components/button"
import Bottombar from "@/components/bottombar"
import { Icon } from "@/icons/icon"
import { DialogDescription } from "@/components/ui/dialog"

export type EndShiftErrorSheetProps = {
  open?: boolean
  mode?: "Self" | "Handover"
  text?: string
  title?: string
  onOpenChange?: (open: boolean) => void
  onClickBack?: () => void
}

export default function EndShiftErrorSheet({
  open,
  mode = "Self",
  text = "",
  title = "End Shift Error",
  onOpenChange,
  onClickBack,
}: EndShiftErrorSheetProps) {
  function getText() {
    if (text) {
      return text
    }

    if (mode === "Self") {
      return (
        <>
          You cannot end process <i>without submitting all sheets</i> or&nbsp;
          <i>removing unsubmitted sheets</i>
        </>
      )
    }

    return (
      <>
        You cannot end process <i>without completing handover case</i> and&nbsp;
        <i>submitting all sheets</i> or <i>removing unsubmitted sheets</i>
      </>
    )
  }

  return (
    <ShadSheet open={open} onOpenChange={onOpenChange}>
      <ShadSheetContent
        side="bottom"
        className="shadow-drop-shadow mx-auto rounded-t-lg"
      >
        <ShadSheetHeader>
          <ShadSheetTitle className="text-xl font-semibold flex flex-col gap-5">
            <div className="h-13 w-13 flex items-center justify-center rounded-full bg-error-light">
              <Icon name="Danger" className="h-7 w-auto text-error" />
            </div>

            <div>{title}</div>
          </ShadSheetTitle>
        </ShadSheetHeader>

        <DialogDescription className="px-4 pb-4">{getText()}</DialogDescription>

        <Bottombar className="bg-white">
          <Button className="w-full" onClick={onClickBack}>
            Go Back
          </Button>
        </Bottombar>
      </ShadSheetContent>
    </ShadSheet>
  )
}
